import React, { useEffect } from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function AboutUs() {
    useEffect(() => {
        const termsAndConditionsView = document.getElementById('AboutUs');
        if (termsAndConditionsView) {
            termsAndConditionsView.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    return (
        <Container id="AboutUs" sx={{
            my: { sm: 0, xs: 5 },
            py: { sm: 16, xs: 12 }
        }} fixed>
            <Box sx={{ minHeight: '50vh' }}>
                <>
                    <Typography variant="h1" component="h1" align="center">
                        About Us
                    </Typography>
                    <br />
                </>
                <br />
                <>
                    <Typography variant="h6" component="h1" align="left">
                        Our Office Locations
                    </Typography>
                    <Typography variant="body1" align="left">
                        1. Harju maakond, Tallinn, Kesklinna linnaosa, Ravi tn 7-2, 10134, Estonia
                        <br />
                        2. H.NO. 323/1F17 NR. GANAPATI TEMPLE, GANAPATIWADA KHANDOLA GOA 403107, INDIA
                    </Typography>
                </>
            </Box>
        </Container>
    );
}